module.exports = __webpack_public_path__ + "band_5.a10f8a3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/band_5.png
// module id = KikK
// module chunks = 0